// Public demonstration only. Never import into authenticated data loaders.
export const explorerDemo = Array.from({
  length: 14
}, (_, i) => [{
  _media: "META",
  campaign_id: "demo-meta-1",
  campaign_name: "리필 라인 · 신규 고객",
  account_id: "demo-meta",
  spend: 220000 + i * 13000,
  revenue: (220000 + i * 13000) * (2.7 + i * .13),
  cv: 19 + i,
  click: 430 + i * 23,
  imp: 34000 + i * 1200
}, {
  _media: "Google",
  campaign_id: "demo-google-1",
  campaign_name: "브랜드 검색 · 구매 의도",
  account_id: "demo-google",
  spend: 140000 + i * 7000,
  revenue: (140000 + i * 7000) * (4.1 + Math.sin(i) * .7),
  cv: 20 + i,
  click: 330 + i * 12,
  imp: 18000 + i * 900
}, {
  _media: "META",
  campaign_id: "demo-meta-2",
  campaign_name: "앰플 세트 · 리타겟팅",
  account_id: "demo-meta",
  spend: 80000 + i * 4000,
  revenue: (80000 + i * 4000) * (3.5 + i * .12),
  cv: 13 + i,
  click: 170 + i * 7,
  imp: 15000 + i * 600
}].map(row => ({
  ...row,
  date: `2026-08-${String(i + 18).padStart(2, "0")}`
}))).flat();
